import { ca } from '@cian/analytics';

export function trackAuctionOpen(isAutobrokerEnabled: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Open',
    label: isAutobrokerEnabled ? 'passive' : 'bid',
  });
}
